export const CSS_CLASSES = {
  RIPPLE_ROOT: "ripple",
};
